import { Component } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import {
  BUTTON_ACTIONS,
  FORMAT_FOR_DATES_LONG,
} from 'src/app/core/helpers/ui/ui.constant';
import { BonusPromotionalCode } from 'src/app/core/interfaces/api/report.interface';
import { ModalWithAction } from 'src/app/core/interfaces/ui/bootstrap-modal.interface';
import { ButtonAction } from 'src/app/core/interfaces/ui/ui.interface';
import { BootstrapModalService } from 'src/app/core/services/ui/bootstrap-modal.service';
import { LanguageService } from 'src/app/core/services/ui/language.service';

@Component({
  selector: 'report-bonus-report-info-modal',
  templateUrl: './bonus-report-info-modal.component.html',
})
export class BonusReportInfoModalComponent {
  public titleModal: string = '';
  public bonusReportInfo: BonusPromotionalCode | undefined = undefined;
  private unsubscribe$: Subject<boolean> = new Subject<boolean>();
  public FORMAT_FOR_DATES_LONG = FORMAT_FOR_DATES_LONG;

  constructor(
    private _bsModalService: BootstrapModalService<
      ModalWithAction<BonusPromotionalCode>
    >,
    public _lang: LanguageService
  ) {}

  ngOnInit(): void {
    this.suscribeModalDataIssued();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  private suscribeModalDataIssued(): void {
    this._bsModalService
      .getDataIssued()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ({ buttonAction, selectedRow }) =>
          this.processSelectedUser(buttonAction, selectedRow),
        error: () => this.closeModal(),
      });
  }

  private processSelectedUser(
    buttonAction: ButtonAction,
    bonusInfo?: BonusPromotionalCode
  ): void {
    this.bonusReportInfo = bonusInfo;

    const executeAction = this.handleProcessButtonAction(buttonAction);
    executeAction();
  }

  private handleProcessButtonAction(buttonAction: ButtonAction): () => void {
    const actionMap = new Map<ButtonAction, () => void>([
      [BUTTON_ACTIONS.VIEW, () => this.handleViewUser()],
    ]);
    return actionMap.get(buttonAction) || (() => {});
  }

  private handleViewUser(): void {
    this.titleModal = 'reports.bonus.title';
  }

  public closeModal(): void {
    this._bsModalService.closeModal();
  }
}
